import { Medscape } from 'www/medscape';
import { loadScript } from 'www/utils/load-script';
import { jsonpRequest } from 'www/utils/jsonp-request';
import { VideoLoaderProxy } from './video-loader-proxy';

import classNames from 'classnames';
if (window.fetch == null) {
    require('isomorphic-fetch');
}



class VideoLoader extends VideoLoaderProxy {
    constructor(videoEl, tracking = {}) {
        super(videoEl, tracking);
    }


    fetch(path = "") {
        const apiUrl = `${this.API_ENDPOINT}/${path}`;
        return jsonpRequest(apiUrl);
    }
    getApiControlSettings(config) {
        let settings = this.DEFAULT_CONTROLS_SETTINGS;
        let {
            enablePlay: play,
            enableProgress: progress,
            enableFullScreen: fullscreen,
            enableScrubbing: scrubbing,
            enableLength: duration,
            enableMute: mute,
            enableCcLangMenu: cc_langMenu,
            enableCc: cc_enable,
            enableCcAutoDisplay: cc_autoDisplay,
            enableVolume: volume,
            enableLooping: loop
        } = config;
        settings = Object.assign(settings, {
            play,
            progress,
            fullscreen,
            scrubbing,
            duration,
            mute,
            volume,
            loop
        })
        settings.cc = Object.assign(settings.cc, {
            enable: cc_enable,
            langManu: cc_langMenu,
            autoDisplay: cc_autoDisplay
        });
        return settings;

    }
    getApiVideoSettings(videoConfig) {
        let { DEFAULT_PLAYER_SETTINGS } = this;
        let {
            source,
            ccFileRoot,
            autoplay,
            poster,
            duration: durationString
        } = videoConfig;
        let duration = this.getDuration(durationString);
        let title = videoConfig.title || this.title;
        //let settings = new this.VideoPlayer.PlayerSettings();

        poster = poster == null || poster.startsWith("/") ? poster : `/${poster}`;
        if (poster != null && poster.startsWith("/en/")) {
            poster = poster.replace("/en/", "/");
        }


        let settings = {
            autoplay,
            poster,
            duration,
            source,
            title,
            controls: {
                enabled: true
            }
        }

        return settings;

    }
    getMapApiData(apiData) {
        let { config } = apiData;
        return {
            apiData: apiData,
            videoSettings: this.getApiVideoSettings(config),
            controlsSettings: this.getApiControlSettings(config)
        }
    }


    load() {
        let { videoEl } = this;
        let { config: endPoint } = videoEl.dataset;
        let promise = new Promise((resolve, reject) => {
            this.fetch(endPoint).then(apiData => {
                    this.apiData = apiData;
                    let mapData = this.getMapApiData(apiData);
                    resolve(mapData);
                },
                error => {
                    reject(error);
                });
        });

        return promise;
    }
}



export { VideoLoader }